var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiscellaneous(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30811 9.47834H6.80811C6.80811 9.75448 7.03197 9.97834 7.30811 9.97834V9.47834ZM5.82053 9.5969C6.09667 9.5969 6.32053 9.37305 6.32053 9.0969C6.32053 8.82076 6.09667 8.5969 5.82053 8.5969V9.5969ZM23.8616 10.0204L23.8956 9.52152L23.8956 9.52152L23.8616 10.0204ZM25.655 11.6325L26.1529 11.6778L26.155 11.6552V11.6325H25.655ZM24.7232 10.0792L24.6891 10.5781L24.7232 10.0792ZM6.80811 2.95579V9.47834H7.80811V2.95579H6.80811ZM7.30811 9.97834H15.9285V8.97834H7.30811V9.97834ZM10.9811 19.3997H19.2851V18.3997H10.9811V19.3997ZM3.07031 2.95579V9.0969H4.07031V2.95579H3.07031ZM3.07031 9.0969V13.1694H4.07031V9.0969H3.07031ZM3.57031 9.5969H5.82053V8.5969H3.57031V9.5969ZM12.7309 2.75024L15.4635 9.66217L16.3935 9.29451L13.6608 2.38258L12.7309 2.75024ZM15.4285 9.47834V12.4864H16.4285V9.47834H15.4285ZM16.9285 13.9864H25.4865V12.9864H16.9285V13.9864ZM15.8944 9.97717L23.8275 10.5192L23.8956 9.52152L15.9626 8.9795L15.8944 9.97717ZM23.8275 10.5192L24.6891 10.5781L24.7573 9.58039L23.8956 9.52152L23.8275 10.5192ZM23.3616 10.0204V10.6325H24.3616V10.0204H23.3616ZM25.155 11.0769V11.6325H26.155V11.0769H25.155ZM25.1571 11.5873L24.5939 17.782L25.5898 17.8726L26.1529 11.6778L25.1571 11.5873ZM24.8616 12.1325H25.655V11.1325H24.8616V12.1325ZM15.4285 12.4864C15.4285 13.3149 16.1001 13.9864 16.9285 13.9864V12.9864C16.6523 12.9864 16.4285 12.7626 16.4285 12.4864H15.4285ZM23.3616 10.6325C23.3616 11.461 24.0331 12.1325 24.8616 12.1325V11.1325C24.5854 11.1325 24.3616 10.9087 24.3616 10.6325H23.3616ZM24.6891 10.5781C24.9514 10.596 25.155 10.814 25.155 11.0769H26.155C26.155 10.2882 25.5442 9.63415 24.7573 9.58039L24.6891 10.5781Z",
    fill: "#F26522"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99663 2.5332H14.126C14.5494 2.5332 14.8926 2.18998 14.8926 1.7666V1.7666C14.8926 1.34322 14.5494 1 14.126 1H2.90918C2.4858 1 2.14258 1.34322 2.14258 1.7666V1.7666C2.14258 2.18998 2.4858 2.5332 2.90918 2.5332H7.66206",
    stroke: "#F26522",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09916 14.5061C3.02284 13.349 4.44535 12.6077 6.04102 12.6077C8.82509 12.6077 11.082 14.8646 11.082 17.6487C11.082 20.4328 8.82509 22.6897 6.04102 22.6897C3.25694 22.6897 1 20.4328 1 17.6487C1 17.3592 1.0244 17.0755 1.07124 16.7994",
    stroke: "#F26522",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.04102,
    cy: 17.6487,
    r: 3.1748,
    stroke: "#F26522"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.561,
    cy: 19.8391,
    r: 3.1748,
    stroke: "#F26522"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5612,
    cy: 19.8392,
    r: 1.65247,
    stroke: "#F26522"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.04089,
    cy: 17.6486,
    r: 1.30603,
    stroke: "#F26522"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2397 6.43573V6.40283C19.2397 5.85055 19.6875 5.40283 20.2397 5.40283H20.959C21.5113 5.40283 21.959 5.85055 21.959 6.40283V8.53442C21.959 9.08671 21.5113 9.53442 20.959 9.53442H20.2397C19.6875 9.53442 19.2397 9.08671 19.2397 8.53442V8.50153",
    stroke: "#F26522",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8604 2.30396L20.6099 3.23145V5.27625",
    stroke: "#F26522",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscellaneous);
export default __webpack_public_path__ + "static/media/miscellaneous.b410694382698886a53cc6ff4e54893f.svg";
export { ForwardRef as ReactComponent };